import { Divider, Link, Stack, Typography, Box } from '@mui/material';
import { AuthForm, User } from '../../../../../types/auth';
import { useState } from 'react';
import { useAppDispatch, useForm } from '../../../../../hooks';
import { useNavigate } from 'react-router-dom';
import { AUTH_API } from '../../../../../api/amplify';
import { GoogleSigninButton } from '../../components/GoogleSigninButton';
import { ElamaSigninButton } from '../../components/ElamaSigninButton';
import { FormButton, FormInput } from '../../../../UI';
import {
  setAuthForm,
  setCognitoUserAuthorized,
  setCognitoUserEmail,
  setCognitoUserPassword,
} from '../../../../../store/CognitoSlice';
import { PATHS } from '../../../../../constants/routes';
import { translateErrorMessage } from '../../../../../utils/authHelpers';
import { showAlert } from '../../../../../store';
import { AlertType } from '../../../../../types/common';
import { SUCCESS_AUTH } from '../../../../../constants/authMessages';

const INIT_USER: User = {
  email: '',
  password: '',
};

declare global {
  interface Window {
    ymGlobal: any;
  }
}

export const Signin = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { input, error, handleChange, submit, handlePressEnter, resetForm } = useForm(INIT_USER, handleSubmit);

  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit() {
    try {
      setIsLoading(true);
      const { email, password } = input;

      dispatch(setCognitoUserEmail(email));
      dispatch(setCognitoUserPassword(password));

      const response = await AUTH_API.signIn(email, password);
      dispatch(showAlert({ type: AlertType.Success, message: SUCCESS_AUTH }));

      if (response) {
        dispatch(setCognitoUserAuthorized());

        navigate(PATHS.dashboard);
        resetForm();
      }
    } catch (e: any) {
      const errorMessage = translateErrorMessage(e);
      dispatch(showAlert({ type: AlertType.Error, message: errorMessage }));
    }

    setIsLoading(false);

    if (window.ymGlobal) {
      window.ymGlobal(90338500, 'reachGoal', 'sign_in');
    }
  }

  const switchToSignupForm = () => {
    dispatch(setAuthForm(AuthForm.Signup));
  };

  const switchToForgotPasswordForm = () => {
    dispatch(setAuthForm(AuthForm.ForgotPassword));
  };

  return (
    <Stack
      sx={{
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
        gap: '60px',
      }}
    >
      <Stack onKeyDown={handlePressEnter}>
        <Typography
          variant="h1"
          mb={'30px'}
          align={'center'}
          sx={{
            typography: {
              mobile: 'h3',
              laptop: 'h1',
            },
          }}
        >
          Войти
        </Typography>

        <Stack gap={'20px'} component={'form'} onSubmit={submit}>
          <GoogleSigninButton />
          <ElamaSigninButton />

          <Box>
            <Divider light>
              <Typography variant="subtitle1">или</Typography>
            </Divider>
          </Box>

          <Box>
            <FormInput
              onChange={handleChange}
              error={error?.email || ''}
              name={'email'}
              value={input.email || ''}
              placeholder={'Email'}
              label={'Email'}
              smallLabel
            />
            <FormInput
              onChange={handleChange}
              error={error?.password || ''}
              name={'password'}
              value={input.password || ''}
              placeholder={'Пароль'}
              label={'Пароль'}
              type={'password'}
              smallLabel
            />
          </Box>
          <Stack gap={'30px'}>
            <Link
              component={'button'}
              onClick={switchToForgotPasswordForm}
              underline={'none'}
              type={'button'}
              alignSelf={'flex-start'}
            >
              Забыли пароль?
            </Link>

            <FormButton submit isLoading={isLoading}>
              Войти
            </FormButton>
            <Box component={'span'}>
              <Typography variant="subtitle1" component={'span'}>
                Еще не зарегистрированы?{' '}
              </Typography>

              <Link component={'button'} onClick={switchToSignupForm} underline={'none'} type={'button'}>
                Зарегистрироваться
              </Link>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
